import { GET } from '../api';

import type { Locales, StrapiFilterParams } from '@monoimin/sb-types';

export async function getDatasources({
  filters,
  locale = 'en',
}: {
  filters?: StrapiFilterParams;
  locale?: Locales;
}) {
  const queryObject: {
    locale: Locales;
    filters?: StrapiFilterParams;
    populate: string;
  } = {
    locale: locale,
    populate: '*',
  };

  if (filters) {
    queryObject.filters = filters;
  }

  const { data } = await GET('/datasources', {
    params: {
      query: queryObject,
    },
  });

  return data;
}

export default getDatasources;
